import * as React from 'react';
import DataTable from 'react-data-table-component';

const columns = [
  {
    selector: row => row['operation_id'] || "NA",
    name: 'Operation Id',
    grow: 5,
  },
  {
    selector: row => row['plant_date'] || "NA",
    name: 'Plant Date',
    sortable: true,
    grow: 3,
  },
  {
    selector: row => row['harvest_date'] || "NA",
    name: 'Harvest Date',
    sortable: true,
    grow: 3,
  },
  {
    selector: row => row['total'] || "NA",
    name: 'kg',
    sortable: true,
    grow: 2,
  },
  {
    selector: row => row['greenhouse_id'] || "NA",
    name: 'Greenhouse',
    sortable: true,
    grow: 4,
  },
  {
    name: 'Argo-Chem 1',
    selector: row => row['Apply Agro-Chemical 1'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 2',
    selector: row => row['Apply Agro-Chemical 2'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 3',
    selector: row => row['Apply Agro-Chemical 3'] || "NA",
    grow: 3,
  },
  {
    name: 'Argo-Chem 4',
    selector: row => row['Apply Agro-Chemical 4'] || "NA",
    grow: 3,
  },
  {
    selector: row => row['Fertilizing 1'] || "NA",
    name: 'Fertilizing 1',
  },
    {
    selector: row => row['Fertilizing 2'] || "NA",
    name: 'Fertilizing 2',
  },
  {
    name: 'Fertilizing 3',
    selector: row => row['Fertilizing 3'] || "NA",
    grow: 3,
  },
  {
    name: 'Fertilizing 4',
    selector: row => row['Fertilizing 4'] || "NA",
    grow: 3,
  },
  {
    name: "Model",
    selector: row => row['cultivation'] || "NA",
    grow: 7,
  },
  {
    name: "Crop",
    selector: row => row['crop'] || "NA",
    grow: 5,
  }
];

const pagination = true
const paginationPage = 25
const paginationRowsPerPageOptions = [25]

const CultivationTable = (rows) => {
  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataTable
        columns={columns}
        data={rows.data}
        pagination={pagination}
        paginationPerPage={paginationPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      />
    </div>
  )
}

export default CultivationTable